import {
  DropImageParameters,
  ScoresOfWellDrops,
  WellNavigationDetails,
} from 'components/Experiment/constants';

export const getNavigatorImageKeysAsString = (
  wellNavigationDetails: WellNavigationDetails,
  DropImageParameters: DropImageParameters,
): string => {
  if (!wellNavigationDetails || !DropImageParameters) {
    return '';
  }

  const imageBatchId = DropImageParameters?.inspection?.groupedInspections?.find(
    (grp) => grp.plateId === wellNavigationDetails?.plateID,
  )?.imageBatchId;
  return `${wellNavigationDetails.plateID}-${wellNavigationDetails.wellNum}-${DropImageParameters.dropNumber}-${DropImageParameters.regionName}-${DropImageParameters.cpId}-${imageBatchId}`;
};

export const getNavFilteredScore = (
  wellDropScores: ScoresOfWellDrops[][],
  wellNumber: number,
  dropNumber: number,
  batchId: number,
) => {
  const scores = wellDropScores
    ?.flat()
    ?.filter(
      (score) =>
        score.wellNumber === wellNumber &&
        score.scoreBatchId === batchId &&
        score.dropNumber === dropNumber,
    );
  return scores;
};
